import React, { memo, useCallback } from "react";
import colors from "app/colors";
import { Button } from "@chakra-ui/react";
import { SearchFilter, SearchFilterType } from "gql/graphql";

interface IProps {
  title: string;
  icon: React.ReactElement;
  searchFilterType: SearchFilterType;
  isDisabled?: boolean;
  newSearchFilters: SearchFilter[];
  setNewSearchFilters: React.Dispatch<React.SetStateAction<SearchFilter[]>>;
}

const FiltersDrawerToggleButton = ({
  title,
  icon,
  searchFilterType,
  isDisabled = false,
  newSearchFilters,
  setNewSearchFilters,
}: IProps) => {
  const isToggled = newSearchFilters.some(
    (filter) => filter.type === searchFilterType,
  );

  const onClick = useCallback(() => {
    setNewSearchFilters((prev) => {
      const _prev = [...prev].filter(
        (filter) => filter.type !== searchFilterType,
      );
      if (!isToggled) {
        _prev.push({ type: searchFilterType });
      }
      return _prev;
    });
  }, [isToggled, searchFilterType, setNewSearchFilters]);

  return (
    <Button
      aria-label="unread"
      size="sm"
      variant="outline"
      rounded="full"
      leftIcon={icon}
      backgroundColor={isToggled ? colors.blueLight : "transparent"}
      iconSpacing={1}
      px={2}
      fontSize={14}
      fontWeight={500}
      onClick={onClick}
      isDisabled={isDisabled}
    >
      {title}
    </Button>
  );
};

export default memo(FiltersDrawerToggleButton);
